'use strict';
import React, { useMemo } from 'react';
import Header from '../common/Header';
import { useNavigate } from "react-router-dom";
import styles from './assets/index.module.scss';
import useService from './service';
import { Tag } from 'antd-mobile';
import { useMount } from 'ahooks';
import Loading from '../../utils/Loading';
import Emptyer from '../../utils/Emptyer';

export default function DDS_lanhupage_0() {

  const navigate = useNavigate();
  const { loading, runKnowledge, knowledgeList } = useService();

  useMount(() => {
    runKnowledge()
  })

  const learn = (v) => {
    navigate(`/lanhu_3?knowledgeId=${v.knowledgeId}&knowledgeName=${v.knowledgeName}`)
  }

  const exam = (knowledgeId, e) => {
    e.stopPropagation()
    navigate(`/lanhu_7?exam=${knowledgeId}`)
  }

  const cntJsx = useMemo(() => {
    if (knowledgeList.length === 0) {
      return <Emptyer desc='还未上传知识点' />
    }
    return <div className={`${styles.mod2} flex-col justify-between`}>
      {
        knowledgeList.map((v, i) => (
          <div key={v.knowledgeId + i} onClick={() => learn(v)}>
            <div className={`${styles.bd2} flex-row justify-between`}>
              <div className={`${styles.bd3} flex-col`}>
                <img
                  className={`${styles.pic1}`}
                  src={v.imgUrl?.replace('http://192.169.250.225:8888', 'https://onlinetest.shasteel.cn')}
                />
              </div>
              <div className={`${styles.bd4} flex-col`}>
                <span className={`${styles.txt2}`}>{v.knowledgeName}</span>
                <span className={`${styles.info1}`}>{v.createdTime.substring(0, 10)}</span>
                <span className={`${styles.txt3}`}>{
                  v.knowledgeStudyFinished === 'N' ? <Tag color='warning'>未学完</Tag> :
                    <>
                      <Tag color='success'>已看完</Tag>
                      {
                        v.score === '100' ?
                          <Tag color='success' style={{ marginLeft: 10 }}>已考完</Tag>
                          :
                          <Tag color='#2db7f5' style={{ marginLeft: 10 }} onClick={(e) => exam(v.knowledgeId, e)}>开始考试</Tag>
                      }
                    </>
                }</span>
              </div>
            </div>
            {
              i < knowledgeList.length - 1 &&
              <img
                className={`${styles.pic2}`}
                src={
                  require('./assets/img/SketchPng2a2b39252316f295592dca01fb91c06dee0a6cf9636c62befc29878553cfb646.png')
                }
              />
            }
          </div>
        ))
      }
    </div>
  }, [knowledgeList])

  return (
    <div className={`${styles.page} flex-col`}>
      <div className={`${styles.bd1} flex-col`}>
        <div className={`${styles.mod1} flex-col`}>
          {/* <Header className={`${styles.group1} flex-col`} /> */}
          <span className={`${styles.txt1}`}>知识点列表</span>
          <div className={`${styles.group2} flex-col`}>
            {loading ? <Loading /> : cntJsx}
          </div>
        </div>
      </div>
    </div>
  );
}
